type MessageJson = Record<string, string>;
type MessageModule = { default: MessageJson };

/** Import git-checked messages */
const importMessages = (): Promise<MessageModule> => {
  return import("./en.json");
};

/** Soapbox locales map */
const messages = () => importMessages().then((messages) => messages.default);

export default messages;
